import Cache from '@fs/zion-cache'

const storeName = 'LYimageQualityAudits'
const cache = new Cache({ storeName })

export function writeToLocalStorage(key, value) {
  cache.setItem(key, value)
}

export async function updateCachedImageArray(key, value) {
  const data = await cache.getItem(key)
  const newData = { ...data, imageInfo: value }

  cache.updateItem(key, newData)
}

export async function getFromLocalStorage(key) {
  const data = await cache.getItem(key)
  const NOW = new Date()

  if (data?.expires?.getTime() < NOW.getTime()) {
    cache.removeItem(key)
    return null
  }

  return data
}

export function removeFromLocalStorage(key) {
  cache.removeItem(key)
}
